import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StationService } from 'src/app/_services/station.service';
import { TableBtn } from '../../../../shared/interfaces/table-btn';
import { TableColumn } from '../../../../shared/interfaces/table-column';
import { SnackbarService} from '../../../../_service/message-service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ExportCSVService } from 'src/app/_services/export-csv.service';

export interface DeviceConfigData {
  id: number;
  key: string;
  value: string;
  description: string;
  readonly: boolean;
}

@Component({
  selector: 'telio-device-config',
  templateUrl: './device-config.component.html',
  styleUrls: ['./device-config.component.scss']
})
export class DeviceConfigComponent implements OnInit {
  actionHeader: string = '';
  columns: TableColumn[];   // this will define what you pass over to the table
  buttons: TableBtn[];      // this will define what you pass over to the table
  data: DeviceConfigData[];         // this is example data but you can use any object to pass to the table
  //stationId: any;
  configTips = [];
  filterPlaceholder: string = '';
  private resetSubs$ = new Subject();
  subs: any;
  initialData: any;
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  @Input() routeID = null;
  @Input() stationId: any;

  constructor(readonly exportCSVService: ExportCSVService, 
    public dialog: MatDialog, 
    readonly stationService: StationService, 
    readonly translate: TranslateService, readonly toasterService: SnackbarService, readonly router: Router) {
  }
  ngOnInit() {
    this.rerender(this.pageList, '');
    this.columns = [
      { columnDef: 'key', header: 'stationDetail.deviceConfig.name', cell: (element: DeviceConfigData) => `${element.key}`, sortingDisabled: false, width: '140px' },
      { columnDef: 'value', header: 'stationDetail.deviceConfig.value', cell: (element: DeviceConfigData) => `${element.value}`, sortingDisabled: false, width: '140px' },
      { columnDef: 'description', header: 'stationDetail.deviceConfig.description', cell: (element: DeviceConfigData) => `${element.description ? element.description : 'NA'}`, sortingDisabled: true, width: '140px' },
      { columnDef: 'readonly', header: 'stationDetail.deviceConfig.accessibility', cell: (element: DeviceConfigData) => `${element.readonly ? 'R' : 'RW'}`, sortingDisabled: false, width: '80px' }
    ];

    // build the buttons; styleClass: button style; icon: which material icon should be used; payload: what value from the object should be returned; action: what name should the action have
    this.buttons = [
      { styleClass: 'submit disabled', icon: 'edit', payload: (element: DeviceConfigData) => `${element.id}`, action: 'edit', tooltip: 'stationDetail.edit' }
    ];

    this.actionHeader = 'stationDetail.deviceConfig.action';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';

    this.configTips.push('stationDetail.deviceConfig.infoTips.one');
    this.configTips.push('stationDetail.deviceConfig.infoTips.two');
    this.configTips.push('stationDetail.deviceConfig.infoTips.three');
  }
  getDeviceConfig(value, searchFilter) {
    this.stationService.getDeviceConfig(this.stationId,value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe(
      (resp: any) => {
        this.data = resp.data;
        this.totalDataCount = resp.totalItems;
        this.data.map((item: any, i: number) => { item.id = i });
      }, err => {
        this.toasterService.error(this.translate.instant('responseFailed'));
      });
  }

  // Use the filtered data from the table and modify the footer accordingly
  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }
  

  // Here we can get the action and payload back from the table
  buttonClick(result: string[]) {
    result[0] == 'edit' ? this.modifyConfig(Number(result[1])) : null;
  }

  modifyConfig(selectedIndex) {
  }

  actionClick() {
    this.rerender(this.pageList, '');  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('stationDetail.configTitle'),
      showTitle: false,
      title: this.translate.instant('stationDetail.configTitle'),
      useKeysAsHeaders: true
    }
    this.stationService.getDeviceConfig(this.stationId,1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe(
      (resp: any) => {
        this.initialData = resp.data;
        this.initialData.map((item: any, i: number) => { item.id = i });
        this.initialData.map(res => {
          res.readonly = res.readonly ? 'R' : 'RW';
        })
        this.exportCSVService.exportCSV(options, this.initialData);
      });
  }

  openDialog() {
    this.subs = this.dialog.open(DialogComponent);
    this.subs.afterClosed().pipe(takeUntil(this.resetSubs$)).subscribe(res => {
    });
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  rerender(value: any, searchFilter?: string) {
    this.getDeviceConfig(value, searchFilter);
  }
}
